import { createFileRoute } from "@tanstack/react-router";
import { DeFiPage } from "../../features/defi/pages/defi-page";

export const Route = createFileRoute("/_layout/defi")({
  loader: () => {
    // Note: We don't prefetch tokens here because we need to know the user's
    // currency preference first, which is only available in component context
    return null; // resolves immediately; route can render
  },
  component: DeFiPage,
});
